import { modulePage } from "../../core/Application";

export class Search implements modulePage {
    readonly name: string = "Search";

    formOrder = document.getElementById("formOrder") as HTMLSelectElement;

    init = (): void => {
        if (this.formOrder) {
            const searchForm = document.getElementById("searchForm") as HTMLFormElement;
            const formOrderBy = document.getElementById("formOrderBy") as HTMLSelectElement;
            const formOrderDir = document.getElementById("formOrderDir") as HTMLSelectElement;

            this.formOrder.addEventListener("change", (e) => {
                const element = e.target as HTMLSelectElement;
                const ordering = element.options[element.selectedIndex].value.split(":");

                formOrderBy.value = ordering[0];
                formOrderDir.value = ordering[1];
                searchForm.submit();
            });
        }
    }
}

export const search = new Search();